__turbopack_context__.v({
  "avatar": "profile-card-module-scss-module__7sx05a__avatar",
  "award": "profile-card-module-scss-module__7sx05a__award",
  "body": "profile-card-module-scss-module__7sx05a__body",
  "card": "profile-card-module-scss-module__7sx05a__card",
  "cta": "profile-card-module-scss-module__7sx05a__cta",
  "fixed": "profile-card-module-scss-module__7sx05a__fixed",
  "head": "profile-card-module-scss-module__7sx05a__head",
  "hr": "profile-card-module-scss-module__7sx05a__hr",
  "icon": "profile-card-module-scss-module__7sx05a__icon",
  "info": "profile-card-module-scss-module__7sx05a__info",
  "logo": "profile-card-module-scss-module__7sx05a__logo",
  "name": "profile-card-module-scss-module__7sx05a__name",
  "ps": "profile-card-module-scss-module__7sx05a__ps",
  "qrcode": "profile-card-module-scss-module__7sx05a__qrcode",
  "secondary": "profile-card-module-scss-module__7sx05a__secondary",
  "subtitle": "profile-card-module-scss-module__7sx05a__subtitle",
  "username": "profile-card-module-scss-module__7sx05a__username",
  "video": "profile-card-module-scss-module__7sx05a__video",
});
